import { render, staticRenderFns } from "./FieldType.vue?vue&type=template&id=2041747d&scoped=true"
import script from "./FieldType.vue?vue&type=script&lang=js"
export * from "./FieldType.vue?vue&type=script&lang=js"
import style0 from "./FieldType.vue?vue&type=style&index=0&id=2041747d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041747d",
  null
  
)

export default component.exports